import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

import { Form } from './Form';

export interface TextAreaProps extends React.ComponentPropsWithoutRef<'textarea'> {
  label?: React.ReactNode;
  hint?: string;
  error?: string;
  touched?: boolean;
}

export const TextArea = ({ error, label, hint, touched, className, ...rest }: TextAreaProps) => {
  const hasError = Boolean(touched && error);
  const hintText = hasError && error ? error : hint;

  const control = <StyledTextArea hasError={hasError} rows={4} {...rest} />;

  return (
    <Form.Group className={className}>
      {label ? (
        <Form.Label>
          {label}
          {control}
        </Form.Label>
      ) : (
        control
      )}
      {hintText && <Form.Hint error={hasError}>{hintText}</Form.Hint>}
    </Form.Group>
  );
};

const StyledTextArea = styled.textarea<{
  disabled?: boolean;
  hasError?: boolean;
}>(({ disabled, hasError }) => [
  tw`
    bg-white
    text-primary-medium
    border
    border-gray-15
    box-border
    cursor-text
    flex
    px-2
    py-1
    rounded-lg
    transition duration-fast
    w-full
    text-base/snug
    placeholder:text-gray-50
    focus:(outline-none text-indigo)
    hover:text-indigo
    disabled:text-gray-30
  `,
  disabled && tw`pointer-events-none bg-white border-gray-15 text-gray-70`,
  hasError
    ? tw`border-error ring-4 ring-error-lightest`
    : tw`focus-within:(border-secondary ring-4 ring-secondary-lighter)`,
]);
